import React from 'react'
import { Box, Button, FormControl, Grid, InputLabel, OutlinedInput, Slide, } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import Dialog from '@mui/material/Dialog';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { createLanguage } from 'utils/APIs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
})

const CreateLanguage = ({open, setopenForm}) => {
    const { t } = useTranslation()

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);

        const formData = JSON.stringify({
            name: data.get('name'),
            code: data.get('code') ,
        });

        if (data.get('name')) {
            try {
                await createLanguage(formData);
                toast.success('Language created Sucessfully');
            } catch (error) {
                toast.error(error?.response?.data?.message || error?.message);
            }
            e.target.reset();
            setopenForm(!open)
            return
        }

        toast.error('name is required while creating language');

    }
    return (
        <div>
            <div>
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    keepMounted
                    aria-describedby="alert-dialog-slide-description"
                    fullWidth
                    maxWidth="sm"
                >
                    <Button
                        variant="secondary"
                        onClick={() => setopenForm(!open)}
                        className="text-center"
                    >
                        {t("Close X")}
                    </Button>
                    <MainCard title="Generate Language" contentClass="card-content">
                        <form noValidate onSubmit={handleFormSubmit}>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="outlined-adornment-University-Name">{t("Name")}</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-University-Name"
                                            type="name"
                                            name="name"
                                            label="Name"
                                            inputProps={{}}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3,mt:3 }}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                        <InputLabel htmlFor="outlined-adornment-University-Name">{t("Code")}</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-University-Name"
                                            type="code"
                                            name="code"
                                            label="code"
                                            inputProps={{}}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 2 }}>
                                <AnimateButton>
                                    <Button fullWidth size="large" type="submit" variant="contained" color="secondary">
                                        {t("Create Language")}
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </form>
                    </MainCard>
                </Dialog>
            </div>
        </div>
    )
}

export default CreateLanguage